module.exports = __webpack_public_path__ + "static/media/openengine-video-3.920c4751.svg";